import {FC} from "react";
import Header from "@memaro/components/Header.tsx";

const ProfileUnknownError: FC = () => (
    <>
        <Header>Onbekende fout</Header>
        <p>
            Er is een onbekende fout opgetreden bij het laden van de herinneringspagina. Probeert u het later opnieuw.
        </p>
    </>
)

export default ProfileUnknownError
